import { render, staticRenderFns } from "./SignatureSettings.vue?vue&type=template&id=cbcd973c&scoped=true&"
import script from "./SignatureSettings.vue?vue&type=script&lang=js&"
export * from "./SignatureSettings.vue?vue&type=script&lang=js&"
import style0 from "./SignatureSettings.vue?vue&type=style&index=0&id=cbcd973c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbcd973c",
  null
  
)

export default component.exports